import {combineReducers} from 'redux';

import list from './list';
import insert from './insert';

export default combineReducers({
  list,
  insert
});
